__turbopack_context__.v({
  "header": "sCERlq_header",
  "privacyNotice": "sCERlq_privacyNotice",
  "supported": "sCERlq_supported",
  "supports": "sCERlq_supports",
  "supportsContainer": "sCERlq_supportsContainer",
  "unsupported": "sCERlq_unsupported",
});
